interface ParsedAmount {
  baseAmount: number
  bonusAmount: number
  currency: string
}

export const parseDenominationAmount = (input: string | undefined): ParsedAmount => {
  const regex = /^(\d+)\s*\+\s*(\d+)\s*(.*)$/
  const match = input?.trim().match(regex)

  if (!match) {
    return {
      baseAmount: 0,
      bonusAmount: 0,
      currency: '',
    }
  }

  const [, baseAmountStr, bonusAmountStr, currency] = match

  return {
    baseAmount: parseInt(baseAmountStr, 10),
    bonusAmount: parseInt(bonusAmountStr, 10),
    currency: currency.trim(),
  }
}
